import { createSlice } from "@reduxjs/toolkit";

interface RecentSearchState {
  data: string[];
}

const initialState: RecentSearchState = {
  data: [],
};

export const recentSearchSlice = createSlice({
  name: "recentSearch",
  initialState,
  reducers: {
    clearData: () => initialState,
    removeAllRecentItems: () => initialState,
    saveSearchItem: (state, action) => {
      let oldData = state.data.filter(it=>it!== action.payload)
      if(oldData.length === 6){
        oldData = oldData.slice(1)
      }
      state.data = [...oldData, action.payload];
    },
  },
});

export const { clearData, saveSearchItem, removeAllRecentItems } = recentSearchSlice.actions;

export default recentSearchSlice.reducer;
